export default {
  title: 'Issued invoices result',
  documentValidation: 'Invoice validation:',
  syntacticValidation: 'Syntactic validation:',
  semanticValidation: 'Semantic validation:',
  summary: 'Summary',
  correctBills: 'Correct invoices',
  rejectedBills: 'Rejected invoices',
  totalBills: 'Total invoices'
}
